import React from 'react';
import {
  Grid,
  Avatar,
  Theme,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { useField } from 'formik';

import FormInput from '../form-input/FormInput';
import UrlMenu from '../form-url-input/UrlMenu';
import { ClassApi } from '../../types/styles';

const useStyle = makeStyles(({ palette, colors }: Theme) => createStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '65px',
    borderBottom: `1px solid ${colors.outlines}`,
    '&:hover': {
      backgroundColor: 'rgba(70%, 92%, 95%, .20)',
    },
  },
  labelContainer: {
    display: 'flex',
    margin: '15px',
    alignItems: 'center',
    color: palette.text.primary,
    letterSpacing: '0.5px',
  },
  label: {
    marginLeft: '15px',
  },
  logo: {
    width: '35px',
    height: '35px',
  },
  inputUnderline: {
    '&:before': {
      border: 'none',
    },
    '&&:hover:before': {
      border: 'none',
    },
  },
  input: {
    color: colors.section,
    fontSize: '14px',
  },
}));

type Props = React.ComponentProps<typeof FormInput> & {
  logo: React.ReactNode;
  classes?: ClassApi<typeof useStyle>;
};

const SocialMedia = ({
  label,
  name,
  logo,
  classes: externalClasses = {},
}: Props) => {
  const meta = useField({ name })[1];
  const classes = useStyle({ classes: externalClasses });

  return (
    <div className={classes.root}>
      <Grid className={classes.labelContainer} item xs={4}>
        <div>
          <Avatar className={classes.logo}>
            {logo}
          </Avatar>
        </div>
        <div className={classes.label}>
          {label}
        </div>
      </Grid>
      <Grid item xs={7}>
        <FormInput
          classes={{
            inputUnderline: classes.inputUnderline,
            input: classes.input,
          }}
          name={name}
        />
      </Grid>
      <Grid item xs={1}>
        <UrlMenu url={meta.value} disabled={Boolean(meta.error)} />
      </Grid>
    </div>
  );
};


export default SocialMedia;
